export default "__VITE_ASSET__C7rF4HPn__"